<script>
import { debugMessage } from '@/utils/debugMessage'
import router from '@/router'
import { isMobile } from '@/utils/check'
// Logout 정의 부분
// 유저 정보와 토큰을 삭제한 이후, 화면을 재갱신한다.
// 자동적으로 /login 화면으로 이동

export default {
  name: 'logout',
  activated() {
    this.call()
  },
  created() {
    this.call()
  },
  methods: {
    call() {
      this.$store.dispatch('Logout').then(() => {
        if (
          location.href.indexOf('div=android') > -1 ||
          location.href.indexOf('div=ios') > -1
        ) {
          cordova_app.saveStorage('autoLogin', false)
          debugMessage('autoLogin: ' + cordova_app.loadStorage('autoLogin'))
          // cordova_app.saveStorage('saveID','')
          // cordova_app.saveStorage('savePW','')
        }
        // location.reload() // 아이폰 버그때문에 아래와 같이 변경
        if (location.href.indexOf('div=ios') > -1) {
          router.replace('/login')
        } else if (location.href.indexOf('div=android') > -1) {
          location.reload(true) // 안드로이드에서는 이렇게 해야 오류가 없음
        } else {
          if (isMobile()) {
            location.reload(true)
          } else {
            router.replace('/login').catch(res => {})
          }
        }
      })
    }
  },
  render: h => h()
}
</script>
